export default "__VITE_ASSET__zzeuqsu6__";